// ================================
// THEME MAPPING UTILITY
// ================================
// Maps database theme names to CSS class indices (-theme-0 through -theme-5)

export const THEME_CSS_MAP = {
  0: "Blaze",  // Maps to -theme-0 CSS class (Red)
  1: "Pulse",  // Maps to -theme-1 CSS class (Green)
  2: "Aura",   // Maps to -theme-2 CSS class (Violet)
  3: "Nova",   // Maps to -theme-3 CSS class (Yellow)
  4: "Frost",   // Maps to -theme-4 CSS class (Cyan)
  5: "Spectrum"   // Maps to -theme-5 CSS class (Rainbow/Multi-color)
};

/**
 * Get CSS class index from theme name
 * @param {string} themeName - Theme name from database (e.g., "Blaze")
 * @returns {number|null} - CSS index (0-5) or null if not found
 */
export const getThemeCssIndex = (themeName) => {
  const index = Object.keys(THEME_CSS_MAP).find(
    key => THEME_CSS_MAP[key] === themeName
  );
  return index !== undefined ? parseInt(index) : null;
};

/**
 * Get theme name from CSS class index
 * @param {number} cssIndex - CSS index (0-5)
 * @returns {string|null} - Theme name or null if not found
 */
export const getThemeName = (cssIndex) => {
  return THEME_CSS_MAP[cssIndex] || null;
};

/**
 * Get CSS class suffix for a theme
 * @param {string} themeName - Theme name from database
 * @returns {string} - CSS class suffix (e.g., "-theme-0")
 */
export const getThemeClass = (themeName) => {
  const index = getThemeCssIndex(themeName);
  return index !== null ? `-theme-${index}` : "-theme-0"; // Default to theme-0
};
